'use client';

import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as React from 'react';
import { cn } from 'v5/platform/dom/cn';
import { StopPropagation } from 'v5/platform/react/StopPropagation';

const Popover: typeof PopoverPrimitive.Root = ({ modal = true, ...props }) => {
  return <PopoverPrimitive.Root modal={modal} {...props} />;
};

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'center', sideOffset = 4, ...props }, ref) => (
  <PopoverPrimitive.Portal
    container={document.getElementById('tailwind-portals')}
    forceMount={props.forceMount}
  >
    <StopPropagation>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'z-50 rounded-md border border-border-default bg-bg-default p-4 text-fg-default shadow-md outline-none',
          'origin-[var(--radix-popover-content-transform-origin)]',
          'data-[state=open]:animate-in data-[state=closed]:animate-out',
          'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
          'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95',
          'data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2',
          'data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
          'max-h-[calc(var(--radix-popover-content-available-height)_-_var(--spacing))] overflow-y-auto',
          [
            'w-auto',
            'min-w-[max(var(--radix-popover-trigger-width),120px)]',
            'max-w-[max(var(--radix-popover-trigger-width),min(500px,var(--radix-popover-content-available-width)))]'
          ],
          className
        )}
        {...props}
        onKeyDown={e => {
          if (e.key === 'Escape') {
            e.stopPropagation();
          }
          props.onKeyDown?.(e);
        }}
      />
    </StopPropagation>
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

const PopoverClose = PopoverPrimitive.Close;

export { Popover, PopoverTrigger, PopoverAnchor, PopoverContent, PopoverClose };
